import store from './index'

export default {
	GetPower: function(modulecode) {
		var power = false;
		store.state.ButtonPowerList.forEach((item) => {
			if (item.modulecode == modulecode) {
				power = true;
			}
		})
		return power;
	}
}



// WEBPACK FOOTER //
// ./src/store/global_variable.js